// extracted by mini-css-extract-plugin
export default {"dates":"SORCommonOptPeriods_dates__Q9V88","radio":"SORCommonOptPeriods_radio__qeIiF","placeHolderShimmer":"SORCommonOptPeriods_placeHolderShimmer__RKdXh"};